import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './FinancialIndicatorsBlock.module.css';
import { useFinancialIndicatorsBlock } from './useFinancialIndicatorsBlock';
import { FinancialIndicatorsBlockHeader } from './Components/FinancialIndicatorsBlockHeader/FinancialIndicatorsBlockHeader';
import { FinancialIndicatorsBlockDiagrams } from './Components/FinancialIndicatorsBlockDiagrams/FinancialIndicatorsBlockDiagrams';
import { ModalReconciliationOfCalculations } from '../../Modals/ModalReconciliationOfCalculations/ModalReconciliationOfCalculations';

interface FinancialIndicatorsBlockProps {
    classes?: string;
}
export const FinancialIndicatorsBlock = memo(({ classes }: FinancialIndicatorsBlockProps) => {
    const {} = useFinancialIndicatorsBlock();

    return (
        <>
            <ModalReconciliationOfCalculations />
            <div
                id="project_documents_and_finance"
                className={classNames(cls.FinancialIndicatorsBlock, [classes])}
            >
                <FinancialIndicatorsBlockHeader />
                <FinancialIndicatorsBlockDiagrams />
            </div>
        </>
    );
});
